/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h } from './index-ef0fa435.js';
import { m as map } from './map-31d895a1.js';
import { h as hooks } from './moment-b1f57f1a.js';
import './_hasPath-4e6157fe.js';
import './isArray-ba17b1aa.js';
import './isObjectLike-0c552769.js';
import './global-3053f997.js';
import './_isIndex-11d39322.js';
import './isLength-dd14023c.js';
import './isObject-036bb226.js';
import './_baseMap-fff80b84.js';
import './_getAllKeys-4fdbf8d3.js';
import './_getTag-35542633.js';

const utilityLogCss = "slot-fb[hidden],slot[hidden]{display:initial !important}lar-list-item{background-color:var(--lar-background-color-step-100, #1a1a1a) !important;color:var(--lar-text-color, #fff) !important}";

const LogEntryList = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.values = '[]';
    this.measuringUnit = '';
    this.webComponentValueType = '';
  }
  render() {
    const values = JSON.parse(this.values);
    const months = values && Array.isArray(values) ? values : [];
    let latestMonth = months.length > 0 ? months[0] : null;
    if (latestMonth && latestMonth.date !== hooks().format('MM-YYYY')) {
      latestMonth = null;
    }
    const entries = map(months, (month, key) => {
      return {
        start: h("lar-translate", { t: 'date.months.' + (hooks(month.date, 'MM-YYYY').month() + 1) }),
        content: '',
        end: (h("div", null, h("small", null, month.abs), h("small", null, this.measuringUnit), " \u2022 ", h("small", null, "\u0394"), " ", month.rel, h("small", null, this.measuringUnit))),
        group: hooks(month.date, 'MM-YYYY').format('YYYY')
      };
    });
    const header = latestMonth ? (h("div", null, h("lar-list-item", null, h("div", { slot: "start" }, h("strong", null, h("lar-translate", { t: "utilityMeter.currentMonthReading" }))), h("div", { slot: "end" }, h("small", null, latestMonth.abs, this.measuringUnit))), h("lar-list-item", null, h("div", { slot: "start" }, h("strong", null, h("lar-translate", { t: "utilityMeter.currentMonthUsage" }))), h("div", { slot: "end" }, h("small", null, latestMonth.rel, this.measuringUnit))))) : null;
    const groups = {};
    return (h("lar-list", null, header, map(entries, entry => {
      // tslint:disable-next-line: no-shadowed-variable
      let header;
      if (!groups[entry.group]) {
        groups[entry.group] = entry.group;
        header = (h("lar-list-header", null, entry.group));
      }
      return (h("div", null, header ? header : null, h("lar-list-item", null, h("div", { slot: "start" }, entry.start), h("div", null, entry.content), h("div", { slot: "end" }, entry.end))));
    })));
  }
};
LogEntryList.style = utilityLogCss;

export { LogEntryList as lar_utility_log };

//# sourceMappingURL=lar-utility-log.entry.js.map